import { render, staticRenderFns } from "./ModalFinalizarCompetencia.vue?vue&type=template&id=41b629b7&scoped=true"
import script from "./ModalFinalizarCompetencia.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalFinalizarCompetencia.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalFinalizarCompetencia.vue?vue&type=style&index=0&id=41b629b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b629b7",
  null
  
)

export default component.exports